module.exports = __webpack_public_path__ + "img/icon2.dcc0933d.png";